<section class="main-aside-header !k-d-flex k-pos-relative k-my-8 k-justify-content-center">
  <div class="k-w-full k-text-center k-flex-0">
    <img
      id="full-logo"
      ngSrc="../../../../.../../../../../assets/img/logo.svg"
      height="33"
      width="100"
      alt="logo"
      priority
    />
    <img
      id="icon-logo"
      ngSrc="../../../../.../../../../../assets/img/logo-icon.svg"
      class="k-d-none m-auto"
      height="175"
      width="107"
      alt="logo"
    />
  </div>

  <div id="toggle-main-aside" class="k-d-flex k-align-self-end k-pos-absolute">
    <a
      class="custom-symbol slide-in k-text-white k-display-inline-block text-decoration-none user-select-none"
      (click)="sidebarService.toggleSidebar(document, aside, mainPanel)"
    >
    </a>
  </div>
</section>

<section class="main-aside-item-wrapper">
  <ul class="k-mt-0 nav parentnav navbar-nav" #parentNavItem>
    @for (menuItem of menuItems; track menuItem) {
      <li
        #parentListItem
        [ngClass]="[menuItem.cssClass, menuItem.subRoutes ? 'has-submenu' : '']"
        [attr.data-item]="menuItem.cssClass"
        class="nav-item k-pos-relative"
      >
        <a
          class="nav-link !k-d-flex k-align-items-center"
          (click)="
            menuItem.subRoutes ? toggleMenu(parentListItem) : goTo(menuItem.path, parentListItem)
          "
        >
          @if (pageMap.getTitle(PageKey.TimeTrackingPageKeys.TimeTracking) === menuItem.title) {
            <ng-container
              *ngTemplateOutlet="clockControls; context: { menuItem: menuItem }"
            ></ng-container>
          } @else {
            <ng-container *ngTemplateOutlet="icon; context: { menuItem: menuItem }"> </ng-container>
            <p class="label !k-ml-3">{{ menuItem.title }}</p>
          }
        </a>

        @if (menuItem.subRoutes) {
          <ul class="nav subnav navbar-nav">
            @for (subItem of menuItem.subRoutes; track subItem) {
              <li>
                <a
                  [routerLink]="[subItem.path]"
                  (click)="setParentAsActive(parentListItem)"
                  routerLinkActive="active"
                  class="nav-link !k-d-flex k-align-items-center"
                >
                  @if (subItem.icon !== "") {
                    <ng-container *ngTemplateOutlet="icon; context: { menuItem: subItem }">
                    </ng-container>
                  }
                  <p class="label">
                    {{ subItem.title }}
                  </p>
                </a>
              </li>
            }
          </ul>
        }
      </li>
    }
  </ul>
</section>

<section id="control-area">
  <app-sidebar-footer></app-sidebar-footer>
</section>

<ng-template let-menuItem="menuItem" #clockControls>
  @let time = clockData()?.[0];
  <ng-container *ngTemplateOutlet="icon; context: { menuItem: menuItem }"> </ng-container>
  @if (!timerActive() && !trackerActive()) {
    <p class="label !k-ml-3">{{ menuItem.title }}</p>
  } @else {
    <p class="!k-ml-3">
      {{ time | timeFormat: TimeFormatType.SecondsToHoursAndMinutesAndSeconds }}
    </p>

    @if (trackerActive() === true) {
      <div id="tracker-active" class="k-ml-2 k-w-full k-pos-relative">
        <div
          class="icon k-pos-absolute"
          [ngClass]="trackerStatus() === TrackerStatus.Pause ? 'user-idle' : 'user-active'"
        >
          <fa-icon
            class="user-idle"
            [icon]="trackerStatus() === TrackerStatus.Pause ? faPause : faCircle"
          ></fa-icon>
        </div>
      </div>
    } @else if (trackerActive() === false) {
      <fa-icon role="button" class="red" [icon]="faStop" size="sm" (click)="toggleTimer()" />
    } @else {
      <!-- Waiting for websocket check-->
      <div class="k-ml-2" style="white-space: nowrap">Waiting for tracker...</div>
    }
  }
</ng-template>

<ng-template let-menuItem="menuItem" #icon>
  <span
    class="icon k-text-white text-decoration-none user-select-none"
    [ngStyle]="{
      'background-image': imageService.isCustomIcon(menuItem.icon)
        ? ('assets/img/navbar/' + menuItem.icon | safeHtml: SecurityContext.STYLE)
        : '',
    }"
  >
    @if (!imageService.isCustomIcon(menuItem.icon)) {
      {{ menuItem.icon }}
    }
  </span>
</ng-template>
